<template>
  <div class="confirmation-button">
    <common-button
      :icon="icon"
      :size="size"
      :type="type"
      @click="openDialog"
      class="confirmation-button__button"
    >
      <slot>{{ text }}</slot>
    </common-button>
  </div>
</template>

<script>
import UIkit from 'uikit';
import CommonButton from '@/components/CommonButton';

export default {
  name: 'confirmation-button',
  components: {
    CommonButton,
  },
  props: {
    confirmationText: String,
    icon: String,
    size: String,
    type: {
      type: String,
      default: 'default',
    },
    text: String,
  },
  methods: {
    async openDialog() {
      this.$emit('click');

      try {
        let text = this.confirmationText;
        if (!text) {
          text = this.$t('defaultConfirmationText');
        }
        await UIkit.modal.confirm(text);
        this.$emit('confirm');
      } catch (error) {
        this.$emit('decline');
      }
    },
  },
  i18n: {
    messages: {
      de: {
        defaultConfirmationText: 'Die gewählte Aktion wirklich ausführen?',
      },
    },
  },
};
</script>

<style lang="scss">
.confirmation-button {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// ConfirmationButton.vue?d15cad9a